import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import * as BABYLON from "@babylonjs/core";

import { SKYBOX_SIZE } from './common';
import { SceneContext } from './context';

const SkyBox = () => {
  const { sceneRef } = useContext(SceneContext);

  useEffect(() => {
    if (!sceneRef) { return; }

    let scene = sceneRef.current;

    let skybox = BABYLON.MeshBuilder.CreateBox("skyBox", {size:SKYBOX_SIZE}, scene);
    let skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
    skyboxMaterial.backFaceCulling = false;
    skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture("/island/skybox/TropicalSunnyDay", scene);
    skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
    skyboxMaterial.disableLighting = true;
    skybox.material = skyboxMaterial;
  }, [ sceneRef ]);

  return null;
};

export default SkyBox;
